import React from "react";
import styles from "@/styles/desktop/InfoSection.module.scss";
import CustomLink from "../CustomLink";
import { InfoSectionProps } from "@/app/interface/components";

const InfoSectionDesktop: React.FC<InfoSectionProps> = ({
	href = "/contato",
	title,
	text,
}) => {
	return (
		<section className={styles.main}>
			<h2 className="h2-medium">{title}</h2>
			<p>{text}</p>
			<div>
				<CustomLink href={href} className="btn-secondary">
					Faça uma cotação
				</CustomLink>
			</div>
		</section>
	);
};

export default React.memo(InfoSectionDesktop);
